/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Be_A_MemberInputs */

const en_be_a_member = /** @type {(inputs: Be_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join Membership`)
};

const es_be_a_member = /** @type {(inputs: Be_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a la Membresía`)
};

const fr_be_a_member = /** @type {(inputs: Be_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoindre l'abonnement`)
};

const de_be_a_member = /** @type {(inputs: Be_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglied werden`)
};

const id_be_a_member = /** @type {(inputs: Be_A_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gabung Keanggotaan`)
};

/** @type {(inputs: Be_A_MemberInputs) => LocalizedString} */
const ja_be_a_member = en_be_a_member;

/** @type {(inputs: Be_A_MemberInputs) => LocalizedString} */
const zh_be_a_member = en_be_a_member;

/** @type {(inputs: Be_A_MemberInputs) => LocalizedString} */
const ar_be_a_member = en_be_a_member;

/** @type {(inputs: Be_A_MemberInputs) => LocalizedString} */
const it_be_a_member = en_be_a_member;

/** @type {(inputs: Be_A_MemberInputs) => LocalizedString} */
const ru_be_a_member = en_be_a_member;

/** @type {(inputs: Be_A_MemberInputs) => LocalizedString} */
const pt_be_a_member = en_be_a_member;

/** @type {(inputs: Be_A_MemberInputs) => LocalizedString} */
const ko_be_a_member = en_be_a_member;

/**
* | output |
* | --- |
* | "Join Membership" |
*
* @param {Be_A_MemberInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const be_a_member = /** @type {((inputs?: Be_A_MemberInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Be_A_MemberInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_be_a_member(inputs)
	if (locale === "es") return es_be_a_member(inputs)
	if (locale === "fr") return fr_be_a_member(inputs)
	if (locale === "de") return de_be_a_member(inputs)
	if (locale === "ja") return ja_be_a_member(inputs)
	if (locale === "zh") return zh_be_a_member(inputs)
	if (locale === "ar") return ar_be_a_member(inputs)
	if (locale === "id") return id_be_a_member(inputs)
	if (locale === "it") return it_be_a_member(inputs)
	if (locale === "ru") return ru_be_a_member(inputs)
	if (locale === "pt") return pt_be_a_member(inputs)
	return ko_be_a_member(inputs)
});